import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {NgClass, NgIf} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {IconName, StandardColor} from '../../../common/types';
import {IconsaxDirective} from '../../../directives/iconsax.directive';
import {HtmlSanitizerPipe} from '../../../pipes/html-sanitizer.pipe';

@Component({
    selector: 'ui-button',
    templateUrl: './ui-button.component.html',
    styleUrls: ['./ui-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, NgClass, TranslateModule, IconsaxDirective, HtmlSanitizerPipe]
})
export class UiButtonComponent {
    @Input() text: string;
    @Input() tooltipIsHtml = false;
    @Input() tooltipText;
    @Input() tooltipPosition: 'toBottomLeft' | 'toBottomRight' | 'toTopLeft' | 'toTopRight' | 'toLeft' | 'toRight' = 'toBottomRight';
    @Input() disabled: boolean;
    @Input() iconName: IconName;
    @Input() bgColor: StandardColor;
    @Input() iconColor: StandardColor;
    @Input() textColor: StandardColor;
    @Input() textArguments: { [key: string]: string | number };
    @Input() borderWidth: '1' | '2' | '3' | '0';
    @Input() iconPosition: 'left' | 'right' = 'left';
    @Input() loaderShow: boolean;
    @Input() hoverColor: StandardColor;
    @Input() justIcon = false;
    @Input() type: string = 'button';
    /** Accessible name of the inner button, translated; an icon-only button needs one. */
    @Input() ariaLabel?: string;
}
